export const socialPostsConstants = {
    SOCIAL_POSTS_FETCH: 'SOCIAL_POSTS_FETCH',
    SOCIAL_POSTS_SUCCESS: 'SOCIAL_POSTS_SUCCESS',
    SOCIAL_POSTS_ERROR: 'SOCIAL_POSTS_ERROR',
    SET_SOCIAL_POSTS: 'SET_SOCIAL_POSTS',
    RESET_SOCIAL_POSTS: 'RESET_SOCIAL_POSTS',
    SOCIAL_POSTS_UPDATE_POST: 'SOCIAL_POSTS_UPDATE_POST',
};

// Per-post outcome (matches backend SocialPostStatus). NOT rolled up into the campaign status —
// surfaced separately as the per-post outcome summary on the campaign row.
export const POST_STATUS = {
    SCHEDULED: 0,
    PUBLISHED: 1,
    FAILED: 2,
    PUBLISHING: 4,
    CANCELLED: 6,
    DELETED: 7,
    REMOVED_EXTERNALLY: 8,
};

export const POST_STATUS_LABEL_KEY = {
    [POST_STATUS.SCHEDULED]: 'common.scheduled',
    [POST_STATUS.PUBLISHED]: 'common.published',
    [POST_STATUS.FAILED]: 'common.unpublished',
    [POST_STATUS.PUBLISHING]: 'common.publishing',
    [POST_STATUS.CANCELLED]: 'common.cancelled',
    [POST_STATUS.DELETED]: 'common.deleted',
    [POST_STATUS.REMOVED_EXTERNALLY]: 'SocialPosts.removedExternally',
};

// Single source for grouping per-post outcomes into the three at-a-glance buckets. Drives both
// the campaign-row summary and the per-post chip tone, so colour and grouping never drift.
export const POST_OUTCOME_GROUPS = [
    { key: 'published', tone: 'success', labelKey: 'common.published', statuses: [POST_STATUS.PUBLISHED] },
    {
        key: 'queued',
        tone: 'warning',
        labelKey: 'SocialPosts.queued',
        statuses: [POST_STATUS.PUBLISHING, POST_STATUS.SCHEDULED],
    },
    {
        key: 'notPublished',
        tone: 'danger',
        labelKey: 'common.unpublished',
        statuses: [POST_STATUS.FAILED, POST_STATUS.CANCELLED, POST_STATUS.DELETED, POST_STATUS.REMOVED_EXTERNALLY],
    },
];

export const POST_STATUS_TONE = POST_OUTCOME_GROUPS.reduce((map, group) => {
    group.statuses.forEach(status => (map[status] = group.tone));
    return map;
}, {});

// Campaign lifecycle phase (matches backend SocialCampaignStatus). Completed means "dispatch
// started" (fire-and-forget), not a rollup of post outcomes.
export const CAMPAIGN_STATUS = {
    DRAFT: 0,
    SCHEDULED: 1,
    COMPLETED: 2,
};

export const CAMPAIGN_STATUS_LABEL_KEY = {
    [CAMPAIGN_STATUS.DRAFT]: 'common.draft',
    [CAMPAIGN_STATUS.SCHEDULED]: 'common.scheduled',
    [CAMPAIGN_STATUS.COMPLETED]: 'common.completed',
};

export const CAMPAIGN_STATUS_TONE = {
    [CAMPAIGN_STATUS.DRAFT]: 'neutral',
    [CAMPAIGN_STATUS.SCHEDULED]: 'info',
    [CAMPAIGN_STATUS.COMPLETED]: 'success',
};

// Order drives the filter UI.
export const FILTERABLE_CAMPAIGN_STATUSES = [
    CAMPAIGN_STATUS.DRAFT,
    CAMPAIGN_STATUS.SCHEDULED,
    CAMPAIGN_STATUS.COMPLETED,
];

export const POST_CHANNEL = {
    GOOGLE: 0,
    FACEBOOK: 1,
    INSTAGRAM: 2,
    TIKTOK: 3,
    X: 4,
    LINKEDIN: 5,
    FACEBOOK_STORY: 6,
    INSTAGRAM_STORY: 7,
};

export const POST_CHANNEL_NAME = {
    0: 'Google',
    1: 'Facebook',
    2: 'Instagram',
    3: 'TikTok',
    4: 'X',
    5: 'LinkedIn',
    6: 'FacebookStory',
    7: 'InstagramStory',
};

export const POST_CHANNEL_LABEL = {
    ...POST_CHANNEL_NAME,
    [POST_CHANNEL.FACEBOOK_STORY]: 'Facebook Story',
    [POST_CHANNEL.INSTAGRAM_STORY]: 'Instagram Story',
};

export const isStoryPlatform = platform =>
    platform === POST_CHANNEL.FACEBOOK_STORY || platform === POST_CHANNEL.INSTAGRAM_STORY;

export const STORY_EXPIRY_HOURS = 24;

export const ANALYTICS_PLATFORMS = [POST_CHANNEL.FACEBOOK, POST_CHANNEL.INSTAGRAM];

const POST_CHANNEL_FROM_NAME = Object.fromEntries(
    Object.entries(POST_CHANNEL_NAME).map(([value, name]) => [name, Number(value)]),
);

export const normalizePlatform = value => (typeof value === 'string' ? POST_CHANNEL_FROM_NAME[value] : value);
